module.exports = __webpack_public_path__ + "static/media/mushroom_dartois.5011556c.JPG";